var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("hr", { staticClass: "divider", style: _vm.cssVars }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }